import Box from "@mui/material/Box";
import {Fade, styled} from "@mui/material";
import React, {useEffect, useState} from "react";
import RegularInstruction from "./components/RegularInstruction";
import {ICompanyAPIKey} from "../../../../../../../../models/CompanyAPIKey";
import { fetchCompaniesAPIKeysByCompany } from "../../../../../../../../services/companyAPIKeysService";
import {useSelector} from "../../../../../../../../redux/store";
import {AppStateType} from "../../../../../../../../redux/reducers";
import {CircularProgress, Link} from "@material-ui/core";
import {calculateDaysLeft, getTextByCurrentLanguage} from "../../../../../../../../utils/functions";
import AlertCompanyAPIKey from "./components/AlertCompanyAPIKey";
import {IUser} from "../../../../../../../../models/User";
import {getUserProfile} from "../../../../../../../../selectors";
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import CustomTabs from "../../../../../../../../components/CustomTabs";
import GTMInstruction from "./components/GTMInstruction";
import AbsoluteLoading from "../../../../../../../../components/AbsoluteLoading";

const Card = styled(Box)`
  background: rgb(32, 45, 63);
  border: 1px solid rgba(238, 238, 238, 0.04);
  border-radius: 8px;
`

const WebmasterInstructionTab = () => {
  const { t } = useTranslation()
  const user = useSelector((state) => state.authReducer.user);
  const property = useSelector((state: AppStateType) => state.propertyReducer.property)!
  const [companyAPIKey, setCompanyAPIKey] = useState<ICompanyAPIKey | undefined>(undefined)
  const [loading, setLoading] = useState(true)
  const userProfile = useSelector<IUser | undefined>(getUserProfile);
  const [isExpired, setIsExpired] = useState(false)
  const [tab, setTab] = useState(0)

  useEffect(() => {
    if (!companyAPIKey && property) {
      fetchCompaniesAPIKeysByCompany(property.company, user!.token).then((response: any) => {
        if (response && response.length > 0) {
          const apiKey = response[response.length - 1]
          const daysLeft = calculateDaysLeft(apiKey?.expiry_date)
          setIsExpired(!Boolean(daysLeft <= 0 ? 0 : 1))
          setCompanyAPIKey(apiKey)
          setLoading(false)
        } else {
          setLoading(false)
        }
      })
    }
  }, [property]);

  const getInstruction = (tab: number) => {
    const TABS: {[key: number]: React.ReactNode} = {
      0: <RegularInstruction companyAPIKey={companyAPIKey} name={getTextByCurrentLanguage(property.name)}/>,
      1: <GTMInstruction companyAPIKey={companyAPIKey} name={getTextByCurrentLanguage(property.name)}/>
    }
    return TABS[tab]
  }

  return (
    <Box>
      <Fade in={true}>
        <Box position={'relative'} minHeight={200}>
          {!loading && isExpired ? (
            <AlertCompanyAPIKey text={t('contract_has_expired')}/>
          ) : null}
          {!loading && !companyAPIKey ? (
            <AlertCompanyAPIKey
              text={t('webmaster_instructions_are_not_available')}
            />
          ) : null}
          {!loading && !companyAPIKey && userProfile?.is_staff ? (
            <AlertCompanyAPIKey
              text={
                <Link component={NavLink} exact to={`/companies/${property.company}`}>
                  {t('create_api_key')}
                </Link>
              }
            />
          ) : null}
          {property && companyAPIKey ? (
            <Box mt={4}>
              <Card>
                <CustomTabs
                  tabs={[t('standard_instruction'), t('google_tag_manager_instruction')]}
                  value={tab}
                  setValue={setTab}
                  fullWidth
                />
                {getInstruction(tab)}
              </Card>
            </Box>
          ) : null}
          <AbsoluteLoading visible={loading} />
        </Box>
      </Fade>
    </Box>
  )
}

export default WebmasterInstructionTab